import { render, staticRenderFns } from "./versionData__form.vue?vue&type=template&id=9dc90eaa"
import script from "./versionData__form.vue?vue&type=script&lang=js"
export * from "./versionData__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports